import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextInput, TextArea } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function MilestonesSignalsPage() {
  const [week1, setWeek1] = useState('');
  const [week2, setWeek2] = useState('');
  const [week3, setWeek3] = useState('');
  const [week4, setWeek4] = useState('');
  const [stopConditions, setStopConditions] = useState('');

  return (
    <TaskPage
      phase="prioritize"
      title="Milestones & Signals"
      pageNumber={4}
      instruction="Add one observable signal per week (usage, quality, behavior), not vanity metrics. What would make us stop mid-cycle?"
      whyItMatters="Concreteness + leading indicators improve feedback quality and help teams 'feed up, feedback, feed forward' effectively."
      coachRail={{
        timing: "10 minutes",
        tips: "Focus on observable signals, not vanity metrics. What would make us stop?",
        debrief: "Are the signals observable? Do we know when to stop?"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Milestone Strip</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[var(--text-sec)] mb-2">Week 1</label>
              <TextInput
                value={week1}
                onChange={(e) => setWeek1(e.target.value)}
                placeholder="One observable signal (usage, quality, behavior)"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-[var(--text-sec)] mb-2">Week 2</label>
              <TextInput
                value={week2}
                onChange={(e) => setWeek2(e.target.value)}
                placeholder="One observable signal"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-[var(--text-sec)] mb-2">Week 3</label>
              <TextInput
                value={week3}
                onChange={(e) => setWeek3(e.target.value)}
                placeholder="One observable signal"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-[var(--text-sec)] mb-2">Week 4</label>
              <TextInput
                value={week4}
                onChange={(e) => setWeek4(e.target.value)}
                placeholder="One observable signal"
              />
            </div>
          </div>
        </div>

        <div className="bg-[var(--coral-dim)] border border-[var(--coral)] p-6">
          <h3 className="text-lg font-semibold text-[var(--coral)] mb-4">Retro Prompt: Stop Conditions</h3>
          <p className="text-sm text-[var(--coral)] mb-4">What would make us stop mid-cycle?</p>
          <TextArea
            label="Stop conditions"
            value={stopConditions}
            onChange={(e) => setStopConditions(e.target.value)}
            placeholder="What signals would indicate we should stop? What would make us pause or pivot?"
            rows={4}
          />
        </div>

        <Callout type="tip" phase="prioritize">
          <p className="text-sm">Focus on leading indicators (usage, quality, behavior) rather than lagging metrics. Make signals observable and measurable.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






